import { render, staticRenderFns } from "./CustomDraggingTable.vue?vue&type=template&id=10d948b5&scoped=true"
import script from "./CustomDraggingTable.vue?vue&type=script&lang=js"
export * from "./CustomDraggingTable.vue?vue&type=script&lang=js"
import style0 from "./CustomDraggingTable.vue?vue&type=style&index=0&id=10d948b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d948b5",
  null
  
)

export default component.exports